import React from 'react'

const Label = ({children, className}) => {

    return children ? (
        <h5 className={`font-body font-semibold text-base leading-6 ${className ? className : ""}`}>- {children}</h5>
    ) : ''
}

export default Label